import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {NavigationExtras, Router} from "@angular/router";
import {
  IonBackButton, IonButton,
  IonContent, IonFooter,
  IonHeader,
  IonList,
  IonToolbar
} from "@ionic/angular";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-email-reminder',
  templateUrl: './email-reminder.page.html',
  styleUrls: ['./email-reminder.page.scss'],
  standalone: true,
  imports: [
    IonHeader,
    IonToolbar,
    IonBackButton,
    IonContent,
    IonList,
    IonButton,
    IonFooter
  ]
})
export class EmailReminderPage {

  constructor(private router: Router) { }

  goLogin(){
      this.router.navigate(['login']);
  }
}
